import { Component, OnInit, ElementRef, ViewChild, TemplateRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DataTablesResponse } from '../shared/models/datatables-response';
import { AuthenticationService } from '../shared/auth/authentication.service';
import { DataTablesModule, DataTableDirective } from 'angular-datatables';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { environment } from '../../environments/environment'
import { OpportunityOfferOutputModel } from '../shared/models/OpportunityOfferOutputModel'
import { PropertyManagementService } from '../shared/providers/property-management.service';
import { ILookUp } from '../shared/models/LookUpOutputModel';
import { CommonService } from '../shared/providers/common.service';
import { ToastService } from '../shared/providers/toast.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ValidationService } from '../shared/providers/validation.service';


@Component({
  selector: 'inquiry-list',
  templateUrl: './inquiry-details.component.html',

})
export class InquiryListComponent implements OnInit {
  protected readonly BASE_URL: string = environment.base_url;
  dtOptions = {};
  table: DataTableDirective;
  offers: OpportunityOfferOutputModel[];
  statusList: ILookUp[];
  modalRef: BsModalRef;
  selectedInquiryId: number;
  currentIndex: number;
  user: any;
  selectedStatus = '';
  currentMenu = '';
  prevPage = null;
  IsLoading = false;
  @ViewChild(DataTableDirective) dtElement: DataTableDirective;

  propGuid = null;
  prevPageRouteLink = null;
  constructor(private modalService: BsModalService, private http: HttpClient, public authService: AuthenticationService, private _propertyManagerService: PropertyManagementService,
    private router: Router, private _toastService: ToastService, private _commonService: CommonService, public _validationService: ValidationService, private activatedRoute: ActivatedRoute) {
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      if (params['property'] !== undefined && params['property'] !== null) {
        this.propGuid = params['property'];
      }
      let routeName = params['prevroute'];
      let routeLink = params['link'];
      if (routeName !== null && routeName !== undefined) {
        this.prevPage = routeName;
        this.prevPageRouteLink = routeLink;
      }
      let fromMenu = params['fromMenu'];
      if (fromMenu !== null && fromMenu !== undefined) {
        this.currentMenu = fromMenu;
      }
    });
  }

  downloadFile = function (downloadPath) {
    this._propertyManagerService.DownloadFile(downloadPath).subscribe(response => {

    });
  }
  deleteInquiry() {
    var inquiryId = this.selectedInquiryId;
    var index = this.currentIndex;
    if (inquiryId > 0) {
      this._propertyManagerService.deleteInquiry(inquiryId).subscribe(response => {
        if (response.toString() == 'true') {
          this.bindFilter();
          this.rowCount = this.rowCount - 1;
          this.offers.splice(index, 1);
          this._toastService.addToast({
            title: 'Success', msg:
              'Inquiry deleted successfully', timeout:
              5000, theme: 'bootstrap', position: 'bottom-right', type: 'success'
          });
        }
        else {
          this._toastService.addToast({
            title: 'Error', msg:
              'Error deleting inquiry', timeout:
              5000, theme: 'bootstrap', position: 'bottom-right', type: 'error'
          });
        }

      });
    }
  }
  isAdmin = false;
  rowCount = 0;
  filterCount = [];
  bindFilter() {
    this._commonService.GetFilterCount(2, this.user.Id).subscribe(response => {
      this.filterCount = response;
    });
  }
  ngOnInit() {
    this._commonService.getLookupsByTypeId(17).subscribe(response => {
      this.statusList = response.map(o => { return { id: o.Id, description: o.Description }; });
    });

    const that = this;
    this.user = this.authService.user;

    this.bindFilter();

    var loggedinUserId = this.user.Id;
    if (this.authService.IsUserRole(this.authService.UserRole.Admin) || this.authService.IsUserRole(this.authService.UserRole.SuperAdmin)) {
      loggedinUserId = 0;
      this.isAdmin = true;
    }

    this.dtOptions = {
      pagingType: 'full_numbers',
      serverSide: true,
      processing: true,
      info: false,
      language: {
        zeroRecords: null,
        processing: `<div class="custom-dt-loader">
        <div class="circle-loader-wrapper">
          <div class="circle-loader-ring"></div>
          <img src="assets/img/logos/logo.png" class="loader-icon" />
        </div>
      </div>
     `,
      },
      "pageLength": 50,
      "order": [[8, "desc"]],
      bLengthChange: false,
      initComplete: () => $('.dataTables_filter').css('display', 'none'),
      ajax: (dataTablesParameters: any, callback: Function) => {
        this.IsLoading = true;
        const filter =
        {
          InquiredId: loggedinUserId,
          PropertyGuid: this.propGuid,
          Type: this.activefilterButton,
        }
        dataTablesParameters.Extra_param = filter;

        const httpHeader = this._validationService.GetAuthHeader();

        that.http
          .post<DataTablesResponse>(
            this.BASE_URL + '/opportunity/inquiries',
            dataTablesParameters, httpHeader
          ).subscribe(resp => {
            that.offers = resp.data ? resp.data : [];

            if (this.rowCount == 0) {
              this.rowCount = resp.recordsTotal;
            }

            if (resp) {
              callback({
                recordsTotal: resp.recordsTotal,
                recordsFiltered: resp.recordsFiltered,
                data: []
              });
              if (resp.data.length === 0) {
                $(".dataTables_paginate.paging_full_numbers").hide();
              }
              else {
                $(".dataTables_paginate.paging_full_numbers").show();
              }
              $(".paginate_button.first,.paginate_button.last").hide();
            } else {
              callback({
                recordsTotal: 0,
                recordsFiltered: 0,
                data: []
              });
              $(".dataTables_paginate.paging_full_numbers").hide();
            }
            this.IsLoading = false;

          });
      },
      columns: [{ data: 'LeadName' },
      { data: 'LeadName' },
      { data: 'Role' },
      { data: 'TenantName' },
      { data: 'State' },
      { data: 'City' },
      { data: 'PrimaryContactName' },
      { data: 'Comments' },
      { data: 'InquiryDate' },
      { data: 'StatusName' }]
    };


  }


  convertUTCDateToLocalDate(InquiryDate: Date) {
    var newDate = new Date(InquiryDate);
    var offset = newDate.getTimezoneOffset() / 60;
    var offsetTime = new Date(newDate.getTime() - (offset * 60 * 1000 * 60));
    return offsetTime;
  }
  selectSattus(event) {
    this.selectedStatus = this._validationService.getSelectedOptionText(event);
  }
  changeInquiryStatus(statusId: number, inquiryId: number) {
    this._propertyManagerService.changeInquiryStatus(statusId, inquiryId).subscribe(response => {
      if (response) {
        this.bindFilter();
        this._toastService.addToast({
          title: 'Success', msg:
            'Status updated successfully', timeout:
            5000, theme: 'bootstrap', position: 'bottom-right', type: 'success'
        });
      }
      else {
        this._toastService.addToast({
          title: 'Error', msg:
            'Error updating status', timeout:
            5000, theme: 'bootstrap', position: 'bottom-right', type: 'error'
        });
      }
    });
    event.preventDefault();
  }


  trackByFn(i: number) {
    return i;
  }
  //changeInquiryStatus(statusId: number, inquiryId: number, i: number, statusName: string) {

  //    this._propertyManagerService.changeInquiryStatus(statusId, inquiryId).subscribe(response => {
  //        if (response.toString() == 'true') {


  //        this._toastService.addToast({
  //            title: 'Success', msg:
  //                'Status updated successfully', timeout:
  //                2000, theme: 'bootstrap', position: 'bottom-right', type: 'success'
  //        });

  //        for (var i = 0; i < this.offers.length; i++) {
  //            if (this.offers[i].InquiryId == inquiryId) {
  //                this.offers[i].StatusName = statusName;
  //            }
  //        }

  //        }
  //        else {
  //            this._toastService.addToast({
  //                title: 'Error', msg:
  //                    'Error updating status', timeout:
  //                    2000, theme: 'bootstrap', position: 'bottom-right', type: 'error'
  //            });
  //        }

  //    });
  //    event.preventDefault();

  //}
  onSearch(text: string) {
    this.dtElement.dtInstance.then(x => x.search(text).draw());
  }

  openModal(template: TemplateRef<any>, classes: any, id: number, index: number) {
    this.modalRef = this.modalService.show(template, { class: classes });
    this.selectedInquiryId = id;
    this.currentIndex = index;
  }
  colors = this._validationService.colorsList;
  activefilterButton = 0;
  onSortData(status: any) {
    this.activefilterButton = status;
    this.dtElement.dtInstance.then(x => x.draw());
  }
}
